<template>
  <div class="presupuestos-internos-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroNumero="filtroNumero"
          :filtroFechaRegistro="filtroFechaRegistro"
          :filtroFechaConfirmacion="filtroFechaConfirmacion"
          :filtroFechaCierre="filtroFechaCierre"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :fechaConfirmacionDesde="fechaConfirmacionDesdeParam"
          :fechaConfirmacionHasta="fechaConfirmacionHastaParam"
          :fechaCierreDesde="fechaCierreDesdeParam"
          :fechaCierreHasta="fechaCierreHastaParam"
          :cliente="cliente"
          :contacto="contacto"
          :numero="numero"
          :accion="accion"
          :numeroPO="numeroPO"
          :usuario="usuario"
          :sortByDescending="sortByDescending"
          :sortByFechaCierreEstimado="sortByFechaCierreEstimado"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card no-header>
          <b-tabs @input="setTabIndex" justified>
            <b-tab title="Pendientes" active>
              <app-presupuestos-pendientes
                estado="pendientes"
                :presupuestos="presupuestosPendientes"
                :tableBusy="tableBusyPendientes"
                :vistaPresupuestos="vistaPresupuestosPendientes"
                :paginaActual="paginaActualPendientes"
                :registrosPorPagina="registrosPorPaginaPendientes"
                :totalPaginas="totalPaginasPendientes"
                :totalRegistros="totalRegistrosPendientes"
                :opcionEditar="Boolean(true)"
                :opcionEditarProduccion="Boolean(true)"
                :opcionBorrar="Boolean(true)"
                :opcionConfirmar="Boolean(true)"
                :opcionEmitirPresupuestoInterno="Boolean(true)"
                :opcionEmitirPresupuestoCliente="Boolean(true)"
                :opcionConsultarImagenesRemitos="Boolean(true)"
                :opcionExportarExcel="opcionExportarExcel"
                :opcionDuplicarPresupuesto="opcionDuplicarPresupuesto"
                :opcionCancelarPresupuesto="opcionCancelarPresupuesto"
                :opcionAutorizarPresupuesto="opcionAutorizarPresupuesto"
                :opcionAgregarPresupuestoAdicional="opcionAgregarPresupuestoAdicional"
                :opcionAddBrief="opcionAddBrief"
                :opcionConsultarBrief="opcionConsultarBrief"
                @consultarPresupuesto="consultar"
                @consultarPresupuestoConsolidado="consultarConsolidado"
                @editarPresupuesto="editarItem"
                @editarProduccion="editarProduccionItem"
                @borrarPresupuesto="borrarItem"
                @confirmarPresupuesto="confirmarPresupuesto"
                @anularConfirmacionPresupuesto="anularConfirmacionPresupuesto"
                @emitirPresupuestoInterno="emitirPresupuestoInterno" 
                @emitirPresupuestoCliente="emitirPresupuestoCliente"
                @emitirCertificadoServicio="emitirCertificadoServicio"
                @actualizarPresupuestos="actualizarPresupuestosPendientes"
                @exportarExcel="exportarExcel"
                @duplicarPresupuesto="duplicarPresupuesto"
                @cancelarPresupuesto="cancelarPresupuesto"
                @autorizarPresupuesto="autorizarPresupuesto"
                @cancelarAutorizacionPresupuesto="cancelarAutorizacionPresupuesto"
                @agregarPresupuestoAdicional="agregarPresupuestoAdicional"
                @consultarImagenes="consultarImagenes"
                @addBrief="addBrief"
                @consultarBrief="consultarBrief">
              </app-presupuestos-pendientes>  
            </b-tab>
            <b-tab title="Confirmados">
              <app-presupuestos-confirmados
                estado="confirmados"
                :presupuestos="presupuestosConfirmados"
                :tableBusy="tableBusyConfirmados"
                :vistaPresupuestos="vistaPresupuestosConfirmados"
                :paginaActual="paginaActualConfirmados"
                :registrosPorPagina="registrosPorPaginaConfirmados"
                :totalPaginas="totalPaginasConfirmados"
                :totalRegistros="totalRegistrosConfirmados"
                :opcionAnularConfirmacion="Boolean(true)"
                :opcionEditar="Boolean(true)"
                :opcionEditarProduccion="Boolean(true)"
                :opcionBorrar="Boolean(true)"
                :opcionEmitirPresupuestoInterno="Boolean(true)"
                :opcionEmitirPresupuestoCliente="Boolean(true)"
                :opcionConsultarImagenesRemitos="Boolean(true)"
                :opcionEmitirCertificadoServicio="opcionEmitirCertificadoServicio"
                :opcionExportarExcel="opcionExportarExcel"
                :opcionDuplicarPresupuesto="opcionDuplicarPresupuesto"
                :opcionCancelarPresupuesto="opcionCancelarPresupuesto"
                :opcionCerrarPresupuesto="opcionCerrarPresupuesto"
                :opcionAutorizarPresupuesto="opcionAutorizarPresupuesto"
                :opcionAgregarPresupuestoAdicional="opcionAgregarPresupuestoAdicional"
                :opcionEmitirFacturaProforma="opcionEmitirFacturaProforma"
                :opcionAddBrief="opcionAddBrief"
                :opcionConsultarBrief="opcionConsultarBrief"
                @consultarPresupuesto="consultar"
                @consultarPresupuestoConsolidado="consultarConsolidado"
                @editarPresupuesto="editarItem"
                @editarProduccion="editarProduccionItem"
                @borrarPresupuesto="borrarItem"
                @confirmarPresupuesto="confirmarPresupuesto"
                @anularConfirmacionPresupuesto="anularConfirmacionPresupuesto"
                @emitirPresupuestoInterno="emitirPresupuestoInterno" 
                @emitirPresupuestoCliente="emitirPresupuestoCliente"
                @emitirCertificadoServicio="emitirCertificadoServicio"
                @actualizarPresupuestos="actualizarPresupuestosConfirmados"
                @exportarExcel="exportarExcel"
                @duplicarPresupuesto="duplicarPresupuesto"
                @cancelarPresupuesto="cancelarPresupuesto"
                @cerrarPresupuesto="cerrarPresupuesto"
                @autorizarPresupuesto="autorizarPresupuesto"
                @cancelarAutorizacionPresupuesto="cancelarAutorizacionPresupuesto"
                @agregarPresupuestoAdicional="agregarPresupuestoAdicional"
                @emitirFacturaProforma="emitirFacturaProforma"
                @consultarImagenes="consultarImagenes"
                @addBrief="addBrief"
                @consultarBrief="consultarBrief">
              </app-presupuestos-confirmados>
            </b-tab>

            <b-tab title="Certificados/Facturados" v-if="getFacturados">
              <app-presupuestos-facturados
                estado="facturados"
                :presupuestos="presupuestosFacturados"
                :tableBusy="tableBusyFacturados"
                :vistaPresupuestos="vistaPresupuestosFacturados"
                :paginaActual="paginaActualFacturados"
                :registrosPorPagina="registrosPorPaginaFacturados"
                :totalPaginas="totalPaginasFacturados"
                :totalRegistros="totalRegistrosFacturados"
                :opcionEditar="Boolean(true)"
                :opcionEditarProduccion="Boolean(true)"
                :opcionEmitirPresupuestoCliente="Boolean(true)"
                :opcionConsultarImagenesRemitos="Boolean(true)"
                :opcionEmitirPresupuestoInterno="Boolean(true)"
                :opcionEmitirCertificadoServicio="opcionEmitirCertificadoServicio"
                :opcionExportarExcel="opcionExportarExcel"
                :opcionDuplicarPresupuesto="opcionDuplicarPresupuesto"
                :opcionCerrarPresupuesto="opcionCerrarPresupuesto"
                :opcionAutorizarPresupuesto="opcionAutorizarPresupuesto"
                :opcionAgregarPresupuestoAdicional="opcionAgregarPresupuestoAdicional"
                :opcionEmitirFacturaProforma="opcionEmitirFacturaProforma"
                :opcionAddBrief="opcionAddBrief"
                :opcionConsultarBrief="opcionConsultarBrief"
                :opcionActualizarCierreEstimado="opcionActualizarCierreEstimado"
                @consultarPresupuesto="consultar"
                @consultarPresupuestoConsolidado="consultarConsolidado"
                @editarPresupuesto="editarItem"
                @editarProduccion="editarProduccionItem"
                @borrarPresupuesto="borrarItem"
                @confirmarPresupuesto="confirmarPresupuesto"
                @anularConfirmacionPresupuesto="anularConfirmacionPresupuesto"
                @emitirPresupuestoCliente="emitirPresupuestoCliente"
                @emitirPresupuestoInterno="emitirPresupuestoInterno"
                @emitirCertificadoServicio="emitirCertificadoServicio"
                @actualizarPresupuestos="actualizarPresupuestosFacturados"
                @exportarExcel="exportarExcel"
                @duplicarPresupuesto="duplicarPresupuesto"
                @cerrarPresupuesto="cerrarPresupuesto"
                @autorizarPresupuesto="autorizarPresupuesto"
                @cancelarAutorizacionPresupuesto="cancelarAutorizacionPresupuesto"
                @agregarPresupuestoAdicional="agregarPresupuestoAdicional"
                @emitirFacturaProforma="emitirFacturaProforma"
                @consultarImagenes="consultarImagenes"
                @addBrief="addBrief"
                @consultarBrief="consultarBrief"
                @actualizarCierreEstimadoPresupuesto="actualizarCierreEstimadoPresupuesto">
              </app-presupuestos-facturados>  
            </b-tab>

            <b-tab title="Cerrados" v-if="getCerrados">
              <app-presupuestos-cerrados
                estado="cerrados"
                :presupuestos="presupuestosCerrados"
                :tableBusy="tableBusyCerrados"
                :vistaPresupuestos="vistaPresupuestosCerrados"
                :paginaActual="paginaActualCerrados"
                :registrosPorPagina="registrosPorPaginaCerrados"
                :totalPaginas="totalPaginasCerrados"
                :totalRegistros="totalRegistrosCerrados"
                :opcionConsultarProduccion="true"
                :opcionConsultarImagenesRemitos="true"
                :opcionEmitirPresupuestoInterno="true"
                :opcionEmitirCertificadoServicio="true"
                :opcionExportarExcel="opcionExportarExcel"
                :opcionDuplicarPresupuesto="opcionDuplicarPresupuesto"
                :opcionAbrirPresupuesto="opcionAbrirPresupuesto"
                @consultarPresupuesto="consultar"
                @consultarPresupuestoConsolidado="consultarConsolidado"
                @editarProduccion="editarProduccionItem"
                @consultarProduccion="consultarProduccionItem"
                @confirmarPresupuesto="confirmarPresupuesto"
                @anularConfirmacionPresupuesto="anularConfirmacionPresupuesto"
                @emitirPresupuestoCliente="emitirPresupuestoCliente"
                @emitirPresupuestoInterno="emitirPresupuestoInterno"
                @emitirCertificadoServicio="emitirCertificadoServicio"
                @actualizarPresupuestos="actualizarPresupuestosCerrados"
                @exportarExcel="exportarExcel"
                @duplicarPresupuesto="duplicarPresupuesto"
                @abrirPresupuesto="abrirPresupuesto"
                @consultarImagenes="consultarImagenes"
                @consultarBrief="consultarBrief">
              </app-presupuestos-cerrados>  
            </b-tab>

            <b-tab title="Todos los Presupuestos" v-if="getTodos">
              <app-presupuestos-todos
                estado="todos"
                :presupuestos="presupuestosTodos"
                :tableBusy="tableBusyTodos"
                :vistaPresupuestos="vistaPresupuestosTodos"
                :paginaActual="paginaActualTodos"
                :registrosPorPagina="registrosPorPaginaTodos"
                :totalPaginas="totalPaginasTodos"
                :totalRegistros="totalRegistrosTodos"
                :opcionEditarProduccion="true"
                :opcionEmitirPresupuestoInterno="true"
                :opcionConsultarImagenesRemitos="true"
                @consultarPresupuesto="consultar"
                @consultarPresupuestoConsolidado="consultarConsolidado"
                @editarProduccion="editarProduccionItem"
                @emitirPresupuestoInterno="emitirPresupuestoInterno" 
                @actualizarPresupuestos="actualizarPresupuestosTodos"
                @consultarImagenes="consultarImagenes"
                @consultarBrief="consultarBrief">
              </app-presupuestos-todos>  
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="ordenCompraNumeroModal"
        title="Ingrese el Número de Orden de Compra"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-orden-compra-numero
        @actualizarNumeroOrdenCompra="actualizarNumeroOrdenCompra"
        @cancelarNumeroOrdenCompra="cancelarNumeroOrdenCompra">
      </app-orden-compra-numero>  
    </b-modal>

    <b-modal ref="duplicadoModal"
        title="Duplicar Presupuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-duplicado
        :clientePresupuesto="clienteSeleccionado"
        @duplicar="duplicar"
        @cancelarDuplicado="cancelarDuplicado">
      </app-duplicado>  
    </b-modal>

    <b-modal ref="cancelacionModal"
        title="Cancelar Presupuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cancelacion
        @cancelarPresupuesto="cancelar"
        @cancelarCancelacion="cancelarCancelacion">
      </app-cancelacion>  
    </b-modal>

    <b-modal ref="aperturaModal"
        title="Abrir Presupuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-apertura
        @abrirPresupuesto="abrir"
        @cancelarApertura="cancelarApertura">
      </app-apertura>  
    </b-modal>

    <b-modal ref="cierreModal"
        title="Cerrar Presupuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cierre
        :requiereObservacionesCierre="requiereObservacionesCierre"
        @cerrarPresupuesto="cerrar"
        @cancelarCierre="cancelarCierre">
      </app-cierre>  
    </b-modal>

    <b-modal ref="autorizacionModal"
        title="Autorizar Presupuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-observaciones
        @save="saveAutorizacion"
        @cancelar="closeAutorizacion">
      </app-observaciones>  
    </b-modal>

    <!-- <b-modal ref="usuariosModal"
        title="Asignación de Usuarios"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-usuarios-seleccion
        :presupuestoInternoId="presupuestoSeleccionado.id"
        @close="closeSeleccionUsuarios">
      </app-usuarios-seleccion>  
    </b-modal> -->

    <b-modal ref="imagenesModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-imagenes
        :presupuestoInternoId="presupuestoSeleccionado.id"
        @close="closeImagenes">
      </app-imagenes>  
    </b-modal>

    <b-modal ref="cotizadorModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-cotizador
        @closeCotizador="closeCotizador">
      </app-cotizador>  
    </b-modal>

    <b-modal ref="briefsModal"
        title="Seleccionar Brief"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-briefs
        :presupuestoInternoId="presupuestoInternoId"
        @briefSeleccionado="briefSeleccionado"
        @closeSeleccionBrief="closeSeleccionBrief">
      </app-briefs>  
    </b-modal>

    <b-modal ref="seleccionFechaModal"
        title="Seleccionar Fecha de Cierre Estimado"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-seleccion-fecha
        :fechaInicial="seleccionFechaInicial"
        descripcion="Fecha de cierre estimada"
        @fechaSeleccionada="actualizarCierrePresupuesto"
        @seleccionFechaCancelada="cancelarActualizacionCierre">
      </app-seleccion-fecha>  
    </b-modal>

    <div class="fixed-btn" v-if="agregarVisible">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>
    <div class="fixed-calculator-btn" v-if="accesoCotizador" >
      <div class="calculator-btn" @click.prevent="consultarCotizador">
          <i class="fa fa-calculator fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import PresupuestosPendientes from './listPresupuestos.vue';
import PresupuestosConfirmados from './listPresupuestos.vue';
import PresupuestosFacturados from './listPresupuestos.vue';
import PresupuestosCerrados from './listPresupuestos.vue';
import PresupuestosTodos from './listPresupuestos.vue';
import OrdenCompraNumero from './OrdenCompraNumero.vue';
import Duplicado from './Duplicado.vue';
import Cancelacion from './Cancelacion.vue';
import Apertura from './Apertura.vue';
import Cierre from './Cierre.vue';
import Observaciones from '../shared/observacionesModal.vue';
import SeleccionFecha from '../shared/seleccionFecha.vue';
// import UsuariosSeleccion from './UsuariosSeleccion.vue';
import Imagenes from './Imagenes.vue';
import Cotizador from '../ordenestrabajos/Cotizador.vue';
import Briefs from './Briefs.vue';
import { createHelpers } from 'vuex-map-fields';
import { getFiltroPresupuestosInternosListVisible } from '../../helpers/user_mv';
import exportPDFPresupuestoCliente from '../../mixins/export_presupuesto_cliente_pdf';
import exportPDFPresupuestoInterno from '../../mixins/export_pdf';
import exportPDFPresupuestoProduccion from '../../mixins/export_presupuesto_produccion_pdf';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'presupuestosinternos/getField',
  mutationType: 'presupuestosinternos/updateField',
});

export default {
  name: 'PresupuestosInternos',
  components: {
    appFiltro: Filtro,
    appPresupuestosPendientes: PresupuestosPendientes,
    appPresupuestosConfirmados: PresupuestosConfirmados,
    appPresupuestosFacturados: PresupuestosFacturados,
    appPresupuestosCerrados: PresupuestosCerrados,
    appPresupuestosTodos: PresupuestosTodos,
    appOrdenCompraNumero: OrdenCompraNumero,
    appDuplicado: Duplicado,
    // appUsuariosSeleccion: UsuariosSeleccion,
    appCancelacion: Cancelacion,
    appApertura: Apertura,
    appCierre: Cierre,
    appObservaciones: Observaciones,
    appSeleccionFecha: SeleccionFecha,
    appImagenes: Imagenes,
    appCotizador: Cotizador,
    appBriefs: Briefs,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    exportPDFPresupuestoCliente,
    exportPDFPresupuestoInterno,
    exportPDFPresupuestoProduccion,
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      loaded: false,

      presupuestoInternoId: 0,
      presupuestoSeleccionado: {},
      clienteSeleccionado: {},
      seleccionFechaInicial: moment(new Date()).format('YYYY-MM-DD'),

      /* Parametro para el cierre de presupuestos */
      requiereObservacionesCierre: false,

      numeroOrdenCompra: '',
      numeroOrdenCompraValida: null,
      numeroOrdenCompraInvalidaMsj: '',

      tabIndex: 0,
      pendientesInicializados: false,
      confirmadosInicializados: false,
      facturadosInicializados: false,
      cerradosInicializados: false,
      todosInicializados: false,
      tableBusyPendientes: false,
      tableBusyConfirmados: false,
      tableBusyFacturados: false,
      tableBusyCerrados: false,
      tableBusyTodos: false,

      getPendientes: true,
      getConfirmados: true,
      getFacturados: true,
      getCerrados: true,
      getTodos: false,

      opcionExportarExcel: false,
      opcionDuplicarPresupuesto: false,
      opcionCancelarPresupuesto: false,
      opcionCerrarPresupuesto: false,
      opcionAbrirPresupuesto: false,
      opcionAgregarPresupuestoAdicional: false,
      opcionEmitirCertificadoServicio: false,
      opcionEmitirFacturaProforma: false,
      opcionAutorizarPresupuesto: false,
      opcionAddBrief: false,
      opcionConsultarBrief: false,
      opcionActualizarCierreEstimado: false,

      accesoCotizador: false
    }
  },
  computed: {
    ...mapFields([
      'presupuestosPendientes',
      'paginaActualPendientes',
      'registrosPorPaginaPendientes',
      'totalRegistrosPendientes',
      'totalPaginasPendientes',

      'presupuestosConfirmados',
      'paginaActualConfirmados',
      'registrosPorPaginaConfirmados',
      'totalRegistrosConfirmados',
      'totalPaginasConfirmados',

      'presupuestosFacturados',
      'paginaActualFacturados',
      'registrosPorPaginaFacturados',
      'totalRegistrosFacturados',
      'totalPaginasFacturados',

      'presupuestosCerrados',
      'paginaActualCerrados',
      'registrosPorPaginaCerrados',
      'totalRegistrosCerrados',
      'totalPaginasCerrados',

      'presupuestosTodos',
      'paginaActualTodos',
      'registrosPorPaginaTodos',
      'totalRegistrosTodos',
      'totalPaginasTodos',

      'filtroNumero',
      'filtroFechaRegistro',
      'filtroFechaConfirmacion',
      'filtroFechaCierre',
      'fechaDesde',
      'fechaHasta',
      'fechaConfirmacionDesde',
      'fechaConfirmacionHasta',
      'fechaCierreDesde',
      'fechaCierreHasta',
      'cliente',
      'contacto',
      'numero',
      'accion',
      'numeroPO',
      'usuario',
      'sortByDescending',
      'sortByFechaCierreEstimado',

      'vistaPresupuestosPendientes',
      'vistaPresupuestosConfirmados',
      'vistaPresupuestosFacturados',
      'vistaPresupuestosCerrados',
      'vistaPresupuestosTodos',
      'agregarVisible'
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    },
    fechaConfirmacionDesdeParam() {
      return moment(this.fechaConfirmacionDesde).format('YYYY-MM-DD');
    },
    fechaConfirmacionHastaParam() {
      return moment(this.fechaConfirmacionHasta).format('YYYY-MM-DD');
    },
    fechaCierreDesdeParam() {
      return moment(this.fechaCierreDesde).format('YYYY-MM-DD');
    },
    fechaCierreHastaParam() {
      return moment(this.fechaCierreHasta).format('YYYY-MM-DD');
    },
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 8: /* Calidad */
        this.opcionExportarExcel = true;
        this.opcionDuplicarPresupuesto = true;
        this.opcionCancelarPresupuesto = true;
        this.opcionAgregarPresupuestoAdicional = true;
        this.opcionEmitirCertificadoServicio = true;
        this.opcionEmitirFacturaProforma = true;
        this.accesoCotizador = true;
        break;
      
      case 3: /* Cuentas */
      case 12: /* Asistente de promociones */
      case 13: /* Asistente de cuentas */
      case 15: /* Coordinador/a de promociones */
      case 16: /* Ejecutivo comercial */
      case 17: /* Asistente comercial */
      case 19: /* Coordinador/a comercial */
      case 20: /* Gerente Comercial */
        this.opcionDuplicarPresupuesto = true;
        this.opcionCancelarPresupuesto = true;
        this.opcionAgregarPresupuestoAdicional = false;
        this.opcionEmitirCertificadoServicio = true;
        this.accesoCotizador = true;
        break;

      case 9: /* Director Ejecutivo */
        this.opcionDuplicarPresupuesto = true;
        this.opcionCancelarPresupuesto = true;
        this.opcionAgregarPresupuestoAdicional = false;
        this.opcionEmitirCertificadoServicio = true;
        // this.opcionEmitirFacturaProforma = true;
        this.accesoCotizador = true;
        break;

      case 4: /* Produccion */
      case 5: /* Diseño */
      case 14: /* Asistente de produccion */
      case 24: /* Coordinador de diseño */
        this.getFacturados = false;
        this.getCerrados = true;
        this.getTodos = true;
        break;

      case 10: /* Asistente de logistica */
        this.getFacturados = true;
        this.getCerrados = false;
        this.getTodos = false;
        break;

      case 6: /* Director Administrativo */
      case 7: /* Asist Administracion */
      case 21: /* Responsable de Finanzas y Proveedores */
      case 22: /* Responsable de Facturacion e Impuestos */
        this.opcionExportarExcel = true;
        this.opcionEmitirFacturaProforma = true;
        break;
    }

    this.opcionAutorizarPresupuesto = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosAutorizar'));
    this.opcionAddBrief = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosAddBrief'));
    this.opcionConsultarBrief = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosConsultarBrief'));
    this.opcionActualizarCierreEstimado = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosActualizarCierreEstimado'));
    this.opcionAbrirPresupuesto = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosAbrir'));
    this.opcionCerrarPresupuesto = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosCerrar'));

    this.getPresupuestos();
  },  
  methods: {
    setTabIndex(e) {
      this.tabIndex = parseInt(e);
    },
    filtrar(filtro) {
      this.filtroNumero = filtro.filtroNumero;
      this.filtroFechaRegistro = filtro.filtroFechaRegistro;
      this.filtroFechaConfirmacion = filtro.filtroFechaConfirmacion;
      this.filtroFechaCierre = filtro.filtroFechaCierre;
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.fechaConfirmacionDesde = filtro.fechaConfirmacionDesde;
      this.fechaConfirmacionHasta = filtro.fechaConfirmacionHasta;
      this.fechaCierreDesde = filtro.fechaCierreDesde;
      this.fechaCierreHasta = filtro.fechaCierreHasta;
      this.cliente = filtro.cliente;
      this.contacto = filtro.contacto;
      this.numero = parseInt(filtro.numero);
      this.accion = filtro.accion;
      this.numeroPO = filtro.numeroPO;
      this.usuario = filtro.usuario;
      this.sortByDescending = filtro.sortByDescending;
      this.sortByFechaCierreEstimado = filtro.sortByFechaCierreEstimado;
      this.paginaActualPendientes = 1;
      this.paginaActualConfirmados = 1;
      this.paginaActualFacturados = 1;
      this.paginaActualCerrados = 1;
      this.paginaActualTodos = 1;
      
      this.getPresupuestos();
    },
    getPresupuestos() {
      if (this.getPendientes) {
        this.getItems('pendientes');
      }
      if (this.getConfirmados) {
        this.getItems('confirmados');
      }
      if (this.getFacturados) {
        this.getItems('facturados');
      }
      if (this.getCerrados) {
        this.getItems('cerrados');
      }
      if (this.getTodos) {
        this.getItems('todos');
      }
    },
    getItems(estado) {
      this.loaded = false;

      if (estado.toLowerCase().trim() == "pendientes") {
        this.tableBusyPendientes = true;
      } else if (estado.toLowerCase().trim() == "confirmados") {
        this.tableBusyConfirmados = true;
      } else if (estado.toLowerCase().trim() == "facturados") {
        this.tableBusyFacturados = true;
      } else if (estado.toLowerCase().trim() == "cerrados") {
        this.tableBusyCerrados = true;
      } else if (estado.toLowerCase().trim() == "todos") {
        this.tableBusyTodos = true;
      }

      this.$store.dispatch('presupuestosinternos/getPresupuestos', estado)
        .then(() => {
          if (estado.toLowerCase().trim() == "pendientes") {
            this.tableBusyPendientes = false;
          } else if (estado.toLowerCase().trim() == "confirmados") {
            this.tableBusyConfirmados = false;
          } else if (estado.toLowerCase().trim() == "facturados") {
            this.tableBusyFacturados = false;
          } else if (estado.toLowerCase().trim() == "cerrados") {
            this.tableBusyCerrados = false;
          } else if (estado.toLowerCase().trim() == "todos") {
            this.tableBusyTodos = false;
          }
          this.loaded = true;
        })
        .catch(error => this.showErrorMsj(error));
    },
    consultar (item) {
      this.$router.push({ name: 'PresupuestoInternoData', 
                          params: { id: item.id }});
    },
    consultarConsolidado (item) {
      this.$router.push({ name: 'PresupuestoInternoDataConsolidado', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'PresupuestoInternoABM', 
                          params: { id: 0 }});
    },
    editarItem (item) {
      this.$router.push({ name: 'PresupuestoInternoABM', 
                          params: { id: item.id }});
    },
    editarProduccionItem (item) {
      this.$router.push({ name: 'PresupuestoInternoProduccion', 
                          params: { id: item.id }});
    },
    consultarProduccionItem (item) {
      this.$router.push({ name: 'PresupuestoInternoProduccion', 
                          params: { id: item.id }});
    },
    borrarItem (params) {
      this.showModalConfirm('¿Desea borrar el presupuesto seleccionado?', 
            this.borrar.bind(this, params), 'Si', null, 'No')
    },
    borrar (params) {
      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/delete', params.item.id)
        .then(() => 
          this.showModalMsj('El presupuesto se borró con éxito', 
            this.getItems.bind(this, params.estado), 
            this.getItems.bind(this, params.estado), 
            'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    

    // usuariosItem (item) {
    //   this.presupuestoSeleccionado = item;
    //   this.$refs.usuariosModal.show();
    // },
    // closeSeleccionUsuarios () {
    //   this.$refs.usuariosModal.hide();
    // },

    confirmarPresupuesto(params) {
      if (params.item.numeroOrdenCompra.trim() == '') {
        this.showModalConfirm('El presupuesto no tiene número de orden de compra ¿Desea asignarle el número en este momento?', 
              this.asignarNumeroOrden.bind(this, params.item.id), 'Si', 
              this.confirmar.bind(this, params.item.id), 'No')

      } else {
        this.showModalConfirm('¿Desea confirmar el presupuesto seleccionado?', 
              this.confirmar.bind(this, params.item.id), 'Si', 
              null, 'No')
      }
    },
    confirmar(presupuestoInternoId) {
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/confirmarPresupuesto', presupuestoInternoId)
        .then(() => {
          this.showModalMsj('El presupuesto se confirmó con éxito', null, null, 'light');
          this.getItems('pendientes');
          this.getItems('confirmados');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    

    anularConfirmacionPresupuesto(params) {
      this.showModalConfirm('¿Desea anular la confirmación del presupuesto seleccionado?', 
            this.anularConfirmacion.bind(this, params.item.id), 'Si', 
            null, 'No')
    },
    anularConfirmacion(presupuestoInternoId) {
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/anularConfirmacionPresupuesto', presupuestoInternoId)
        .then(() => {
          this.showModalMsj('La confirmación del presupuesto se anuló con éxito', null, null, 'light');
          this.getItems('pendientes');
          this.getItems('confirmados');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    

    emitirPresupuestoCliente(item) {
      let empresa = {};

      this.showSpinner();
      this.$store.dispatch('empresa/inicializar')
        .then(() => {
          empresa = this.$store.getters['empresa/empresa'];
          return;
        })
        .then(() => {
          return this.$store.dispatch('presupuestoCliente/getPresupuestoCliente', item.id);
        })
        .then(() => {
          let presupuesto = this.$store.getters['presupuestoCliente/presupuesto'];

          this.exportPDFPresupuestoCliente(presupuesto, empresa);
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => {
          this.hideSpinner();
        })
    },
    emitirPresupuestoInterno(item) {
      let empresa = {};
      this.showSpinner();
      this.$store.dispatch('empresa/inicializar')
        .then(() => {
          empresa = this.$store.getters['empresa/empresa'];
          //console.log(empresa);
          return;
        })
        .then(() => {
          return this.$store.dispatch('presupuestointernoproduccion/getDatos', item.id);
        })
        .then(() => {
          let presupuesto = this.$store.getters['presupuestointernoproduccion/presupuestoInterno'];
          let ordenes = this.$store.getters['presupuestointernoproduccion/ordenesTrabajoDatos'];

          this.exportPDFPresupuestoProduccion(presupuesto, ordenes, empresa);
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => {
          this.hideSpinner();
        })
    },
    emitirCertificadoServicio(item) {
      if (this.opcionEmitirCertificadoServicio) {
        this.$router.push({ name: 'CertificadoServicioAdd', 
                            params: { presupuestoId: item.id }});
      }
    },
    emitirFacturaProforma(item) {
      if (this.opcionEmitirFacturaProforma) {
        this.$router.push({ name: 'FacturaProformaABM', 
                            params: { presupuestoId: item.id }});
      }
    },
    // exportarPDF (item) {
    //   let params = {
    //     presupuestoId: item.id
    //   }
    //   this.showSpinner();
    //   this.$store.dispatch('presupuestoInternoDatos/getDatos', params)
    //     .then(() => {
    //       this.exportPDFPresupuestoInterno(this.$store.getters['presupuestoInternoDatos/presupuestoDatosRpt'], 
    //         this.$store.getters['presupuestoInternoDatos/ordenesDatos']);
    //     })
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner())
    // },
    exportarExcel (item) {
      let params = {
        presupuestoId: item.id
      }
      this.showSpinner();
      this.$store.dispatch('presupuestoInternoDatos/getDatos', params)
        .then(() => {
          this.exportXLSPresupuestoInterno(this.$store.getters['presupuestoInternoDatos/presupuestoDatosRpt'], 
            this.$store.getters['presupuestoInternoDatos/ordenesDatos']);
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    duplicarPresupuesto (item) {
      this.presupuestoSeleccionado = item;
      this.clienteSeleccionado = {
        id: item.clienteId,
        nombre: item.cliente.trim()
      };
      this.$refs.duplicadoModal.show();
    },
    duplicar(params) {
      this.$refs.duplicadoModal.hide();
      
      params.presupuestoInternoId = this.presupuestoSeleccionado.id;

      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/duplicarPresupuesto', params)
        .then(() => {
          this.showModalMsj('El presupuesto se duplicó con éxito', null, null, 'light');
          this.getPresupuestos();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarDuplicado() {
      this.$refs.duplicadoModal.hide();
    },

    cancelarPresupuesto (item) {
      this.presupuestoSeleccionado = item;
      this.$refs.cancelacionModal.show();
    },
    cancelar(params) {
      this.$refs.cancelacionModal.hide();

      params.presupuestoInternoId = this.presupuestoSeleccionado.id;

      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/cancelarPresupuesto', params)
        .then(() => {
          this.showModalMsj('El presupuesto se canceló con éxito', null, null, 'light');
          this.getPresupuestos();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarCancelacion() {
      this.$refs.cancelacionModal.hide();
    },

    asignarNumeroOrden(presupuestoInternoId) {
      this.presupuestoInternoId = presupuestoInternoId;
      this.$refs.ordenCompraNumeroModal.show();
    },
    actualizarNumeroOrdenCompra(numeroOrdenCompra) {
      this.$refs.ordenCompraNumeroModal.hide();

      /* Actualizamos el presupuesto y lo confirmamos */
      let params = {
        presupuestoInternoId: this.presupuestoInternoId,
        numeroOrdenCompra: numeroOrdenCompra
      }
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/actualizarNumeroOrdenCompra', params)
        .then(() => this.confirmar(this.presupuestoInternoId))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarNumeroOrdenCompra() {
      this.$refs.ordenCompraNumeroModal.hide();
    },
    actualizarPresupuestosPendientes(paginaActual) {
      this.paginaActualPendientes= paginaActual;
      this.getItems('pendientes');
    },
    actualizarPresupuestosConfirmados(paginaActual) {
      this.paginaActualConfirmados= paginaActual;
      this.getItems('confirmados');
    },
    actualizarPresupuestosFacturados(paginaActual) {
      this.paginaActualFacturados= paginaActual;
      this.getItems('facturados');
    },
    actualizarPresupuestosCerrados(paginaActual) {
      this.paginaActualCerrados= paginaActual;
      this.getItems('cerrados');
    },
    actualizarPresupuestosTodos(paginaActual) {
      this.paginaActualTodos= paginaActual;
      this.getItems('todos');
    },

    cerrarPresupuesto(params) {
      if ((/true/i).test(params.item.cerrado)) {
        this.showModalMsj('El presupuesto seleccionado se encuentra cerrado', null, null, 'light');
      } else {
        // this.showModalConfirm('¿Desea cerrar el presupuesto seleccionado?', 
        //   this.cerrar.bind(this, params.item.id), 'Si', 
        //   null, 'No');
        let paramsCierre = {
          presupuestoInterno: params.item,
          requiereObservacionesCierre: parseFloat(params.item.pjeCertificado) != 100 || parseFloat(params.item.pjeFacturado) != 100
        }
        this.showModalConfirm('¿Desea cerrar el presupuesto seleccionado?', 
          this.consultarMotivosCierre.bind(this, paramsCierre), 'Si', 
          null, 'No');
      }
    },
    consultarMotivosCierre(params) {
      this.presupuestoSeleccionado = params.presupuestoInterno;
      this.requiereObservacionesCierre = (/true/i).test(params.requiereObservacionesCierre);
      this.$refs.cierreModal.show();
    },
    cerrar(params) {
      params.presupuestoInternoId = this.presupuestoSeleccionado.id;
      this.$refs.cierreModal.hide();

      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/cerrarPresupuesto', params)
        .then(() => {
          this.showModalMsj('El presupuesto se cerró con éxito', null, null, 'light');
          this.getPresupuestos();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarCierre() {
      this.$refs.cierreModal.hide();
    },

    abrirPresupuesto(params) {
      if (!(/true/i).test(params.item.cerrado)) {
        this.showModalMsj('El presupuesto seleccionado se encuentra abierto', null, null, 'light');
      } else {
        this.presupuestoSeleccionado = params.item;
        this.$refs.aperturaModal.show();
      }
    },
    abrir(params) {
      params.presupuestoInternoId = this.presupuestoSeleccionado.id;
      this.$refs.aperturaModal.hide();

      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/abrirPresupuesto', params)
        .then(() => {
          this.showModalMsj('El presupuesto se abrió con éxito', null, null, 'light');
          this.getPresupuestos();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarApertura() {
      this.$refs.aperturaModal.hide();
    },

    autorizarPresupuesto(item) {
      this.presupuestoSeleccionado = item;
      this.$refs.autorizacionModal.show();
    },
    saveAutorizacion(params) {
      this.$refs.autorizacionModal.hide();
      params.presupuestoInternoId = this.presupuestoSeleccionado.id;
      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/autorizarPresupuesto', params)
        .then(() => this.showModalMsj('El presupuesto se autorizó con éxito', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    closeAutorizacion() {
      this.$refs.autorizacionModal.hide();
    },
    cancelarAutorizacionPresupuesto(item) {
      this.showModalConfirm('¿Desea cancelar la autorización del presupuesto?', 
        this.cancelarAutorizacion.bind(this, item.id), 'Si', null, 'No');
    },
    cancelarAutorizacion(presupuestoInternoId) {
      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/cancelarAutorizacionPresupuesto', presupuestoInternoId)
        .then(() => this.showModalMsj('La autorización del presupuesto se canceló con éxito', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    agregarPresupuestoAdicional(item) {
      this.showModalConfirm('¿Desea agregar un presupuesto adicional al seleccionado?', 
        this.agregarAdicional.bind(this, item.id), 'Si', 
        null, 'No');
    },
    agregarAdicional(presupuestoInternoId) {
      this.$router.push({ name: 'PresupuestoInternoAdicional', 
                          params: { presupuestoInicialId: presupuestoInternoId }});
    },

    consultarImagenes(item) {
      this.presupuestoSeleccionado = item;
      this.$refs.imagenesModal.show()
    },
    closeImagenes() {
      this.$refs.imagenesModal.hide();
    },

    consultarCotizador() {
      this.$refs.cotizadorModal.show();
    },
    closeCotizador() {
      this.$refs.cotizadorModal.hide();
    },
    
    addBrief(params) {
      this.showModalConfirm('¿Desea generar el brief de diseño para el presupuesto seleccionado?', 
        this.agregarBrief.bind(this, params), 'Si', 
        null, 'No');
    },
    agregarBrief(params) {
      this.showSpinner();
      this.$store.dispatch('brief/addBriefByPresupuesto', params.item.id)
        .then(() => {
          let briefId = this.$store.getters['brief/briefId'];

          this.showModalConfirm('El brief de diseño se generó con éxito. ¿Desea abrirlo en este momento?', 
            this.abrirBrief.bind(this, briefId), 'Si', 
            this.getItems.bind(this, params.estado), 'No');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    abrirBrief(briefId) {
      this.$router.push({ name: 'BriefEdit', 
                          params: { id: briefId }});
    },
    consultarBrief(item) {
      if (item.briefId != 0) {
        /* Consulto el único brief asociado */
        this.$router.push({ name: 'BriefData', 
                            params: { id: item.briefId }});
      } else {
        /* Selecciono del listado de briefs del presupuesto */
        this.presupuestoInternoId = item.id;
        this.$refs.briefsModal.show();
      }
    },
    briefSeleccionado(briefId) {
      this.$refs.briefsModal.hide();
      if (briefId != 0) {
        this.$router.push({ name: 'BriefData', 
                            params: { id: briefId }});
      }
    },
    closeSeleccionBrief() {
      this.$refs.briefsModal.hide();
    },

    actualizarCierreEstimadoPresupuesto(item) {
      this.presupuestoInternoId = item.id;
      this.seleccionFechaInicial = moment(new Date()).format('YYYY-MM-DD');
      this.$refs.seleccionFechaModal.show();
    },
    actualizarCierrePresupuesto(fechaCierre) {
      this.$refs.seleccionFechaModal.hide();

      const params = {
        presupuestoInternoId: this.presupuestoInternoId,
        fecha: fechaCierre
      }

      this.showSpinner();
      this.$store.dispatch('presupuestointerno/actualizarCierreEstimado', params)
        .then(() => {
          return this.$store.dispatch('presupuestosinternos/setCierreEstimadoPresupuesto', params);
        })
        .then(() => this.showModalMsj('La fecha de cierre estimada se actualizó con éxito', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());

    },
    cancelarActualizacionCierre() {
      this.$refs.seleccionFechaModal.hide();
    }
  },
  validations: {
    numeroOrdenCompra: {
      required,
      maxLength: maxLength(50)
    },
  },  
  watch: {
    /*
    'paginaActual' : function(newVal, oldVal) {
      if (this.loaded) {
        if ( newVal != 0 && oldVal != 0) {
          this.getItems('pendientes') 
        }
      }
    },
    */    
  }    
}
</script>

<style>
</style>
